import React, { useEffect, useState } from 'react';
import { Container } from '@groupelacentrale/contact-storybook';
import { useHistory } from 'react-router-dom';
import { ContactInformationForm, ContactInformationProForm, Loader } from 'components';
import { useApp, useDeposit } from 'providers';
import { User } from 'types';
import { TRACKING_PAGES, UserManagementService } from 'api';
import { ROUTES } from 'routes';
import { usePageTracking } from 'hooks';
import { DepositPageContainer } from './DepositPageContainer';

export const ContactInformationPage: React.FC = () => {
  const { user } = useApp();
  const history = useHistory();
  const [userData, setUserData] = useState<User>();
  const [loading, setLoading] = useState(true);
  const { vehicle } = useDeposit();

  if (!vehicle.version) {
    history.replace(ROUTES.vehicleVersionChoice);
  }

  usePageTracking(user!.isPro ? TRACKING_PAGES.CONTACT_PRO : TRACKING_PAGES.CONTACT_PART);

  useEffect(() => {
    UserManagementService.getUser(user!.id)
      .then(setUserData)
      .finally(() => setLoading(false));
  }, [user]);

  return (
    <>
      {loading ? (
        <Loader />
      ) : (
        <DepositPageContainer isPro={user!.isPro}>
          <Container
            className={`contact-information${user!.isPro ? '-pro-' : '-'}form`}
            shadowed
            backgroundColor="bgWhite"
            tag="form"
            paddings="mediumP"
          >
            {user!.isPro ? (
              <ContactInformationProForm user={userData!} />
            ) : (
              <ContactInformationForm user={{ ...userData!, userCorrelationId: user!.userCorrelationId }} />
            )}
          </Container>
        </DepositPageContainer>
      )}
    </>
  );
};
